module.exports = __webpack_public_path__ + "img/spain-lung-cancer-male.9e70b342.png";